import { useT } from "@/i18n/LanguageContext";

export default function Advantages() {
  const { t } = useT();
  const items = t.advantages.items;
  return (
    <section
      id="advantages"
      data-testid="advantages-section"
      className="relative bg-[#0A0A0A] border-b border-white/10"
    >
      <div className="grid grid-cols-12 border-b border-white/10">
        <div className="col-span-12 md:col-span-3 border-r border-white/10 px-6 sm:px-8 py-10 md:py-20">
          <p className="text-[10px] uppercase tracking-[0.3em] text-white/50">
            {t.advantages.label}
          </p>
        </div>
        <div className="col-span-12 md:col-span-9 px-6 sm:px-10 py-10 md:py-20">
          <h2
            data-testid="advantages-headline"
            className="font-display font-bold uppercase tracking-tighter text-white text-4xl sm:text-5xl lg:text-6xl leading-[0.95] max-w-3xl"
          >
            {t.advantages.title}
          </h2>
          <p className="mt-6 text-base text-white/70 max-w-xl">
            {t.advantages.intro}
          </p>
        </div>
      </div>

      <div className="grid grid-cols-12">
        {items.map((it, i) => {
          const isLastCol = (i + 1) % 3 === 0;
          const isLastRow = i >= items.length - 3;
          return (
            <div
              key={it.k}
              data-testid={`advantage-${it.k}`}
              className={`group col-span-12 md:col-span-4 px-6 sm:px-10 py-10 md:py-12 ${
                !isLastCol ? "md:border-r" : ""
              } border-white/10 ${
                !isLastRow ? "border-b" : "border-b md:border-b-0"
              } hover:bg-white/[0.03] transition-colors`}
            >
              <p className="font-display text-xs uppercase tracking-[0.3em] text-white/40">
                {it.k}
              </p>
              <h3 className="font-display text-2xl sm:text-3xl font-bold uppercase tracking-tight text-white mt-6 leading-[1.05]">
                {it.t}
              </h3>
              <p className="text-sm text-white/60 mt-4 leading-relaxed">
                {it.d}
              </p>
            </div>
          );
        })}
      </div>
    </section>
  );
}
